import { fulfilled, pending, rejected } from '../../../utils';
import { APPLICATION } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	message: '',
	data: '',
	error: '',
};

const applicationReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(APPLICATION):
			return {
				...state,
				loading: true,
				message: '',
				error: '',
			};
		case fulfilled(APPLICATION):
			return {
				...state,
				loading: false,
				status: action.payload.data.status,
				message: action.payload.data.message,
				data: action.payload.data.data,
				error: '',
			};
		case rejected(APPLICATION):
      const status = action.payload.response.status
			return {
				...state,
				loading: false,
				message: '',
				error: status ===500 ? "Something went wrong. Please try again later" : action?.payload?.response.data.message,
			};
		default:
			return state;
	}
};

export default applicationReducer;
